import { render, staticRenderFns } from "./Brandschutz.vue?vue&type=template&id=77035287&scoped=true&"
import script from "./Brandschutz.vue?vue&type=script&lang=js&"
export * from "./Brandschutz.vue?vue&type=script&lang=js&"
import style0 from "./Brandschutz.vue?vue&type=style&index=0&id=77035287&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77035287",
  null
  
)

export default component.exports